
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAsLZklrdL805MgMV8Uh1yY2YKzXPK9TUY",
  authDomain: "pumpous-app.firebaseapp.com",
  projectId: "pumpous-app",
  storageBucket: "pumpous-app.firebasestorage.app",
  messagingSenderId: "78111343503",
  appId: "1:78111343503:web:d5310578fffe6febeb81fa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the initialized services
export const db = getFirestore(app);
// getAuth()'s automatic "detect the best available persistence" probe is a
// documented hang risk inside a Capacitor iOS WKWebView -- it loads under a
// custom capacitor://localhost origin (not plain http/https), and Firebase's
// IndexedDB-availability auto-detection can stall indefinitely there (no
// error, no success -- exactly "stuck on Logging in..." forever). Explicitly
// listing the persistence fallback chain via initializeAuth() skips that
// special auto-detect codepath in favor of trying each option in order,
// which several Capacitor+Firebase issue threads report as the fix. This is
// the same effective fallback order getAuth() uses by default, so plain web
// (non-Capacitor) behavior is unchanged.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, inMemoryPersistence]
});
export const storage = getStorage(app);
// Must match the region the Cloud Functions in functions/index.js actually
// deploy to (REGION there) -- onCall functions have no automatic
// colocation with anything, so a mismatched region here would mean
// httpsCallable() calls a function that doesn't exist there and 404s.
export const functions = getFunctions(app, "northamerica-northeast1");